import "./profile-card.scss";
import config from "../../app.json";
import React from "react";
import { useNavigate } from "react-router-dom";
import Image from "../Image/image";

function ProfileCard(props) {
  const { id, firstName, lastName, role, pictureGuid } = props;

  let navigate = useNavigate();

  const handleEditUser = (id) => {
    return navigate(`/users/edit/${id}`, { replace: false });
  };

  return (
    <div className="profile-card">
      <div className="user-primary-info">
        <div className="user-info">
          <div className="user-info-name">
            {firstName} {lastName}
          </div>
          <div className="user-info-role">
            {role == "ROLE_CHURCH_ADMIN" ? "Admin" : role == "ROLE_CHURCH_PRODUCER" ? "Producer" : "Media Manager"}
          </div>
        </div>
        <div className="user-avatar" onClick={() => handleEditUser(id)}>
          <Image
            radius={16}
            src={
              pictureGuid
                ? config.API + "/api/file/download/?guid=" + pictureGuid
                : null
            }
            alt="alt"
            width={56}
            height={56}
          />
        </div>
      </div>
    </div>
  );
}

export default ProfileCard;
